import React, { useState } from 'react'
import { FlexContainer, YSpacing } from '@components/common'
import { LabelInfo } from '@components/common/form'
import { BiPencil } from 'react-icons/bi'
import { MdExpandMore, MdExpandLess } from 'react-icons/md'

import { ClientGlobalSettings, ClientSettings } from '@types'

interface BudgetPerPersonSettingsSummaryProps {
  clientGlobalSettings: ClientGlobalSettings
  clientSettingsCollection: ClientSettings[]
  toggleBudgetPerLocationModal: (value: boolean) => void
}

const BudgetPerPersonSettingsSummary: React.FC<
  BudgetPerPersonSettingsSummaryProps
> = ({
  clientGlobalSettings,
  clientSettingsCollection,
  toggleBudgetPerLocationModal,
}) => {
  const [expanded, setExpanded] = useState(false)
  const { budgetPerPersonSettings, isCustomBudgetPerPerson } =
    clientGlobalSettings

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  return (
    <div className="budget-per-person-settings-summary">
      <div className="summary-header">
        <h3>Budget Per Person Settings</h3>
        <div>
          <button
            onClick={() => toggleBudgetPerLocationModal(true)}
            className="edit-button"
          >
            <div className="button-content">
              <BiPencil />
              <div>Edit</div>
            </div>
          </button>
        </div>
      </div>
      <FlexContainer justifyContent="space-between" flexDirection="column">
        <FlexContainer
          justifyContent="space-between"
          flexDirection="row"
          alignItems="center"
          width="100%"
        >
          {isCustomBudgetPerPerson ? (
            <p className="font-bold text-md mb-2">
              Location Custom Budget Per Person
            </p>
          ) : (
            <p className="font-bold text-md mb-2">Global Budget Per Person</p>
          )}
          <button onClick={toggleExpanded} className="edit-button">
            <div className="button-content">
              {expanded ? <MdExpandLess /> : <MdExpandMore />}
              <div>{expanded ? 'Hide' : 'Show'} Budget Settings</div>
            </div>
          </button>
        </FlexContainer>
        <YSpacing height="10px" />
        {expanded && (
          <>
            {isCustomBudgetPerPerson ? (
              <>
                <YSpacing height="5px" />
                {clientSettingsCollection
                  .filter(({ id }) => id !== undefined && id !== '')
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((clientSettings, idx) => {
                    const { id, name } = clientSettings
                    const budgetPerPerson = budgetPerPersonSettings[id]

                    return (
                      <div
                        key={`client-settings-${idx}-${id}`}
                        className="my-2"
                      >
                        <FlexContainer
                          justifyContent="space-between"
                          flexDirection="column"
                        >
                          <p className="font-bold text-md mb-2">
                            {name === '' ? 'Unnamed Default Location' : name}
                          </p>
                          <FlexContainer
                            justifyContent="space-between"
                            flexDirection="row"
                          >
                            <LabelInfo
                              label="Budget Per Person"
                              value={
                                budgetPerPerson
                                  ? `$${budgetPerPerson.value.toFixed(2)} - ${
                                      budgetPerPerson.type === 'allIn'
                                        ? 'All In (Includes Fees)'
                                        : 'Food Only (Excludes Fees)'
                                    }`
                                  : 'N/A'
                              }
                            />
                          </FlexContainer>
                        </FlexContainer>
                      </div>
                    )
                  })}
              </>
            ) : (
              <LabelInfo
                label="Global Budget Per Person"
                value={
                  budgetPerPersonSettings?.all
                    ? `$${budgetPerPersonSettings.all.value.toFixed(2)} - ${
                        budgetPerPersonSettings.all.type === 'allIn'
                          ? 'All In (Includes Fees)'
                          : 'Food Only (Excludes Fees)'
                      }`
                    : 'N/A'
                }
              />
            )}
          </>
        )}
        <YSpacing height="10px" />
      </FlexContainer>
    </div>
  )
}

export default BudgetPerPersonSettingsSummary
